import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import moment from 'moment';
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';
import { Link } from 'react-router-dom';
import { useUser } from '../../utils/userContext';
import "../../styles/claims.css"


const UploadPolicy = () => {
    const [policies, setPolicies] = useState([]);
    const [currentPolicy, setCurrentPolicy] = useState({ name: '', type: '', description: '', file: null, fileName: '', renewalDate: '' });
    const [filePreview, setFilePreview] = useState(null);
    const [modalPreview, setModalPreview] = useState(null);
    const handleErrors = useHandleErrors();
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [getPolicies, setGetPolicies] = useState([]);
    const [data, setData] = useState([]);
    const [file, setFile] = useState([]);
    const [fileName, setFileName] = useState("");
    const [Description, setDescription] = useState("");
    const { user } = useUser();
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCurrentPolicy({ ...currentPolicy, [name]: value });
    };

    const addPolicy = () => {
        if (currentPolicy.name && currentPolicy.type && currentPolicy.description && currentPolicy.file) {
            setPolicies([...policies, { ...currentPolicy, id: Date.now() }]);
            setCurrentPolicy({ name: '', type: '', description: '', file: null, fileName: '', renewalDate: '' });
            setFilePreview(null);
        } else {
            toast.info("Please fill all fields and select a file.", {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    };

    const deletePolicy = (id) => {
        setPolicies(policies.filter(policy => policy.id !== id));
    };

    const handleSubmit = async () => {
        if (policies.length === 0) {
            toast.info("Please add at least one policy before submitting.", {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }

        for (let i = 0; i < policies.length; i++) {
            const policy = policies[i];
            if (!policy.name || !policy.type || !policy.description || !policy.file || !policy.renewalDate) {
                toast.info(`Please fill all fields for Policy ${i + 1}.`, {
                    position: toast.POSITION.TOP_CENTER,
                });
                return;
            }
        }

        const formData = new FormData();

        policies.forEach((policy, index) => {
            formData.append(`policyName[${index}]`, policy.name);
            formData.append(`policyDescription[${index}]`, policy.description);
            formData.append(`policyType[${index}]`, policy.type);
            formData.append(`policyFile[${index}]`, policy.file);
            formData.append(`renewalDate[${index}]`, policy.renewalDate);
            formData.append(`updatedBy[${index}]`, user?.EmployeeId);
        });

        try {
            const path = "/policyUpload";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 200) {
                toast.success("Policy Uploaded Successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setPolicies([])
                fetchPolicies();
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    };

    const handleReset = () => {
        setPolicies([])
        setCurrentPolicy({ name: '', type: '', description: '', file: null, fileName: '', renewalDate: '' });
        setFilePreview(null);
    };

    const handleCancel = () => {
        setDescription('');
        setFile([]);
        setFileName("")
    };

    const closeModal = () => {
        setModalPreview(null);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === 'application/pdf' || file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')) {
            setCurrentPolicy({ ...currentPolicy, file, fileName: file.name });
            setFilePreview(file.type === 'application/pdf' ? URL.createObjectURL(file) : null);
        } else {
            toast.info("Please select a valid PDF or DOC file.", {
                position: toast.POSITION.TOP_CENTER,
            });

        }
    };

    const openFilePreview = (file) => {
        if (file.type === 'application/pdf') {
            setModalPreview(URL.createObjectURL(file));
        } else {
            setModalPreview(null);
            toast.info("Preview not available for Word files. The file will be downloaded.", {
                position: toast.POSITION.TOP_CENTER,
            });
            window.open(URL.createObjectURL(file));
        }
    };

    const getpolicyDetails = async () => {
        try {
            const path = "/policyDetails";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.status === 200) {
                setData(response.data.policies)
                return response.data.policies;
            }
            else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setData([]);
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    };

    const fetchPolicies = async () => {
        try {
            const policyData = await getpolicyDetails();
            setGetPolicies(policyData);
            setFilteredData(policyData)
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
            console.error('Error fetching guest data', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchPolicies();
            hasFetchedRef.current = true;
        }
    }, []);

    const handleDownload = (documentURL) => {
        console.log("documentURwerL", documentURL)
        if (documentURL) {
            console.log("documentURL", documentURL)
            const link = document.createElement('a');
            const fileName = decodeURIComponent(documentURL.substring(documentURL.lastIndexOf('/') + 1));
            link.href = documentURL;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    // update code
    const handleUpdateFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setFileName(selectedFile.name);
        }
    };

    const handleUpdate = async (policyName, policyType) => {

        if (!file || !Description) {
            toast.error("Please provide both a file and a description.!", {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        const formData = new FormData();
        formData.append(`policyName[0]`, policyName);
        formData.append(`policyDescription[0]`, Description);
        formData.append(`policyType[0]`, policyType);
        formData.append(`policyFile[0]`, file);
        formData.append(`updatedBy[0]`, user?.EmployeeId);

        try {
            const path = "/policyUpload";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 200) {
                toast.success("Policy Updated successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setFile([])
                setFileName("")
                setDescription("")
                fetchPolicies()
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    };

    // end

    // share code
    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Policies');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            const today = new Date();
            const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
            const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
            const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
            const formattedDate = `${year}${month}${day}`;
            link.download = `WW360-Upload Policies_Report_${formattedDate}.xlsx`;

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Policies List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const handleExport = () => {
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Policies');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(data, `WW360-Upload Policies_Report_${formattedDate}.xlsx`);
    };

    const shareData = {
        title: 'Policies List',
        text: 'Check out the Policies list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };
    // end


    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData?.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredData?.length / recordsPerPage);


    const paginate = pageNumber => setCurrentPage(pageNumber);


    return (
        <div>
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Policies</h3>
                        </div>
                        <div class="col-auto">
                            <Link to={'/policies'} class="btn btn-primary mt-lg-0 mt-4"><i class="ri-file-copy-2-line"></i> View All Policies</Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card mb-4">
                                <div className="card-body" id="uploadPolicyDetails">
                                    <h5 className="title accordion-title" data-toggle="collapse" data-target="#uploadPolicies">Upload</h5>
                                    <div className="collapse show" id="uploadPolicies" data-parent="#uploadPolicyDetails">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-lg-5">
                                                <div className="container-fluid row-rounded mb-0">
                                                    <div className="row px-2 py-0">
                                                        <div className="input-group">
                                                            <div className="custom-file">
                                                                <input type="file" className="custom-file-input" id="uploadPolicies" onChange={handleFileChange} />
                                                                <label className="custom-file-label" htmlFor="uploadPolicies">Choose file</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <small className="form-text text-muted text-center mt-0"><i className="ri-information-2-fill text-info"></i> Allows: Word Files - PDF Files </small>
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-md-12">
                                                <div className="table-responsive asset-information">
                                                    <table className="table grid">
                                                        <thead className="bg-light">
                                                            <tr>
                                                                <th width="20%">Policy/Document Name</th>
                                                                <th width="20%">Policy Type</th>
                                                                <th width="30%">Description</th>
                                                                <th width="20%">File</th>
                                                                <th width="20%">Renewal Date</th>
                                                                <th width="10%"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <input type="text" className="form-control" name="name" value={currentPolicy.name} onChange={handleInputChange} />
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-control" name="type" value={currentPolicy.type} onChange={handleInputChange} />
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-control" name="description" value={currentPolicy.description} onChange={handleInputChange} />
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-control" name="fileName" value={currentPolicy.fileName} readOnly />
                                                                </td>
                                                                <td>
                                                                    <input type="date" className="form-control" name="renewalDate" value={currentPolicy.renewalDate} onChange={handleInputChange} />
                                                                </td>
                                                                <td className="text-center">
                                                                    <button className="btn btn-secondary btn-action" type="button" title="Assign" onClick={addPolicy}>
                                                                        <i className="ri-add-circle-line"></i> Add
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="table-responsive policies-list">
                                                    <table className="table grid">
                                                        <thead className="bg-light">
                                                            <tr>
                                                                <th width="5%">S.No.</th>
                                                                <th width="20%">Policy Name </th>
                                                                <th width="20%">Policy Type </th>
                                                                <th width="25%">Description  </th>
                                                                <th width="20%">File</th>
                                                                <th width="20%">Renewal Date</th>
                                                                <th width="10%"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {policies?.map((policy, index) => (
                                                                <tr key={policy.id}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{policy.name}</td>
                                                                    <td>{policy.type}</td>
                                                                    <td>{policy.description}</td>
                                                                    <td>
                                                                        <button className="btn btn-link" type="button" onClick={() => openFilePreview(policy.file)}>
                                                                            {policy.fileName}
                                                                        </button>
                                                                    </td>
                                                                    <td>{policy.renewalDate}</td>

                                                                    <td className="text-center">
                                                                        <button className="btn btn-link text-danger btn-action" type="button" title="Delete" onClick={() => deletePolicy(policy.id)}>
                                                                            <i className="ri-delete-bin-6-line"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-4">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <h5 class="title mt-1 mb-0">Summary</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" title="Email" className="btn btn-light btn-circle ml-2" onClick={() => sendEmail('')}>
                                                <i className="ri-mail-send-fill"></i>
                                            </button>
                                            <button type="button" title="Share" className="btn btn-light btn-circle ml-2" onClick={handleShare}>
                                                <i className="ri-share-fill"></i>
                                            </button>
                                            <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={handleExport}>
                                                <i className="ri-export-fill"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="row mt-3">
                                        <div class="col-md-12">
                                            <div class="table-responsive leave-information">
                                                {data?.length === 0 ? (
                                                    <div class="container">
                                                        <div class="row justify-content-center align-items-center">
                                                            <div class="col-auto">
                                                                <div class="no-data-wrapper">
                                                                    <div class="no-data-found">
                                                                        <i class="ri-file-damage-fill"></i>
                                                                        <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                                                        <p>No Data Found</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <table class="table grid">
                                                        <thead class="bg-light">
                                                            <tr>
                                                                <th>S.No.</th>
                                                                <th>Policy Name</th>
                                                                <th>Policy Type</th>
                                                                <th>Uploaded On</th>
                                                                <th>Created By</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {currentRecords?.map((policy, index) => (
                                                                <tr key={policy.policyId}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{policy.policyName}</td>
                                                                    <td>{policy.policyType}</td>
                                                                    <td>{moment(policy.createdDate).format("DD-MM-YYYY")}</td>
                                                                    <td>{policy.createdBy}</td>
                                                                    <td class="text-center">
                                                                        <span>
                                                                            <button
                                                                                className="btn btn-link text-info btn-action custom-dropdown-btn"
                                                                                type="button"
                                                                                title="Documents"
                                                                                data-toggle="dropdown"
                                                                            >
                                                                                <i className="ri-file-2-line"></i>
                                                                            </button>
                                                                            <div id={`viewDocuments-${policy.policyName}`} className="dropdown-menu dropdown dropdown-menu-right custom-dropdown shadow">
                                                                                <div className="row">
                                                                                    <div className="col-12 mb-2 border-bottom">
                                                                                        <h6>Policy Name: {policy.policyName}</h6>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row drop-down-scroll">
                                                                                    {policy?.policyFileURL && (
                                                                                        <div className="col-12 mb-2">
                                                                                            <button className="btn btn-link text-danger btn-action" type="button">
                                                                                                <i className="ri-eye-line"></i>
                                                                                            </button>
                                                                                            <a href={policy.policyFileURL} target="_blank" rel="noopener noreferrer" className="filename">
                                                                                                {decodeURIComponent(policy.policyFileURL.substring(policy.policyFileURL.lastIndexOf('/') + 1))}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                <div className="row">
                                                                                    <div className="col-12 text-center">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() => handleDownload(policy?.policyFileURL)}
                                                                                        >
                                                                                            Download <i className="ri-file-download-line"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </span>
                                                                        <span>
                                                                            <button class="btn btn-link text-info btn-action" data-target="updatePolicy1" data-toggle="dropdown" type="button" title="Update" rel="tooltip">
                                                                                <i class="ri-list-settings-line"></i>
                                                                            </button>
                                                                            <div id="updatePolicy1" className="dropdown-menu dropdown dropdown-menu-right custom-dropdown shadow">
                                                                                <div className="row">
                                                                                    <div className="col-12 mb-2 border-bottom">
                                                                                        <h6>Policy: {policy.policyName}</h6>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row drop-down-scroll">
                                                                                    <div className="col-lg-12 col-md-12">
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="costDetails" className="required">Document</label>
                                                                                            <div className="custom-file">
                                                                                                <input type="file" className="custom-file-input" id="uploadEmpofferletter" onChange={handleUpdateFileChange} />
                                                                                                <label className="custom-file-label" htmlFor="uploadEmpofferletter">{fileName}</label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="form-group col-12">
                                                                                        <label htmlFor="notifyDescription" className="required">Description</label>
                                                                                        <input type="text" className="form-control" name="description" value={Description} onChange={(e) => setDescription(e.target.value)} />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row">
                                                                                    <div className="col-12 text-center">
                                                                                        <button type="cancel" className="btn btn-light" onClick={handleCancel}>Cancel</button>
                                                                                        <button type="button" className="btn btn-primary" onClick={() => handleUpdate(policy.policyName, policy.policyType)}>Update <i className="ri-checkbox-circle-line"></i></button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="container-fluid">
                                                <div className="row border-top pt-3">
                                                    <div className="col-auto">
                                                        <p className="mt-1 mb-0">Records</p>
                                                    </div>
                                                    <div className="col-1 record-drop">
                                                        <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                            <option value="5">5</option>
                                                            <option value="10">10</option>
                                                            <option value="15">15</option>
                                                            <option value="20">20</option>
                                                            <option value="25">25</option>
                                                        </select>
                                                    </div>
                                                    <div className="col">
                                                        <nav>
                                                            <ul className="pagination justify-content-center">
                                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                        <i className="ri-arrow-left-double-line"></i>
                                                                    </button>
                                                                </li>
                                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                        <i className="ri-arrow-left-s-line"></i>
                                                                    </button>
                                                                </li>
                                                                {Array.from({ length: totalPages }, (_, index) => (
                                                                    <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                        <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                            {index + 1}
                                                                        </button>
                                                                    </li>
                                                                ))}
                                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                        <i className="ri-arrow-right-s-line"></i>
                                                                    </button>
                                                                </li>
                                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                        <i className="ri-arrow-right-double-fill"></i>
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                    <div className="col-auto">
                                                        <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {modalPreview && (
                    <div className="modal" style={{ display: 'block' }} onClick={closeModal}>
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">File Preview</h5>
                                    <button type="button" className="close" onClick={closeModal}>&times;</button>
                                </div>
                                <div className="modal-body">
                                    <iframe src={modalPreview} width="100%" height="500px" title="File Preview"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="row fixed-footer">
                <div className="col-lg-12 text-center ONBfirstTab">
                    <button className="btn btn-light" type="reset" onClick={handleReset}>
                        Reset
                    </button>
                    <button
                        className="btn btn-primary btnNext"
                        type="button"
                        onClick={handleSubmit}
                    >
                        Submit <i className="ri-checkbox-circle-line"></i>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default UploadPolicy
